import '../scss/index.scss';
import App from './App';

//import { isLoadedImages } from "./utils/isLoadedImages";

const app = new App();
app.render();

// const preloadImages = document.querySelectorAll('[data-js-preload-images]')
// isLoadedImages(preloadImages).then(() => {

// })

// top
$(".tp-gallery_grid_item-col3 .top-gallery_image-view .tp-gallery_figure >img").click(function () {
  var src = $(this).attr("src");
  var cap = $(this).attr("alt")
  $(".modal-block").fadeIn()
  $(".modal-block").css("transiton", "0.5s")
  $(".modal-block").css("display", "flex")

  $("#popup").attr("src", src);
  $(".caption").text(cap);
})
$(".img-section >span , .modal-block").click(function () {
  $(".modal-block").css("display", "none")
  $(".modal-block").css("transiton", "0.5s")
})



    //アコーディオンをクリックした時の動作
    $('.accordion-title-name').on('click', function() {//タイトル要素をクリックしたら
        var findElm = $(this).next('.accordion-body');//直後のアコーディオンを行うエリアを取得し
        $(findElm).slideToggle();//アコーディオンの上下動作
          
        if($(this).hasClass('close')){//タイトル要素にクラス名closeがあれば
          $(this).removeClass('close');//クラス名を除去し
        }else{//それ以外は
          $(this).addClass('close');//クラス名closeを付与
        }
      });



    //任意のタブにURLからリンクするための設定
function GethashID (hashIDName){
    if(hashIDName){
      //タブ設定
      $('.tp-gallery_flters li').find('a').each(function() { //タブ内のaタグ全てを取得
        var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得 
        if(idName == hashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
          var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
          $('.tp-gallery_flters li').removeClass("active"); //タブ内のliについているactiveクラスを取り除き
          $(parentElm).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
          //表示させるエリア設定
          $(".area").removeClass("is-active"); //もともとついているis-activeクラスを取り除き
          $(hashIDName).addClass("is-active"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加 
        }
      });
    }
  }
  
  //タブをクリックしたら
  $('.tp-gallery_flters a').on('click', function() {
    var idName = $(this).attr('href'); //タブ内のリンク名を取得  
    GethashID (idName);//設定したタブの読み込みと
    return false;//aタグを無効にする
  });
  
  
  // 上記の動きをページが読み込まれたらすぐに動かす
  $(window).on('load', function () {
      $('.tp-gallery_flters li:first-of-type').addClass("active"); //最初のliにactiveクラスを追加
      $('.area:first-of-type').addClass("is-active"); //最初の.areaにis-activeクラスを追加
    var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
    GethashID (hashName);//設定したタブの読み込み
  });



//画像の設定

var windowwidth = window.innerWidth || document.documentElement.clientWidth || 0;
    if (windowwidth > 768){
      var responsiveImage = [//PC用の画像
    //   開発環境用
        // { src: '//localhost:3000/sun-58/wp-content/themes/sun_58/src/assets/images/fv-slide_img02.jpg'},
        // { src: '//localhost:3000/sun-58/wp-content/themes/sun_58/src/assets/images/fv-slide_img01.jpg'},
        // { src: '//localhost:3000/sun-58/wp-content/themes/sun_58/src/assets/images/fv-slide_img03.jpg'},
    //   テスト環境用
        // { src: 'https://sun-58.lulls.work/wp-content/themes/sun_58/src/assets/images/fv-slide_img02.jpg'},
        // { src: 'https://sun-58.lulls.work/wp-content/themes/sun_58/src/assets/images/fv-slide_img01.jpg'},
        // { src: 'https://sun-58.lulls.work/wp-content/themes/sun_58/src/assets/images/fv-slide_img03.jpg'},
    //   本番環境用
        { src: 'https://www.nizius.co.jp/sun58/wp-content/themes/sun_58/src/assets/images/fv-slide_img02.jpg'},
        { src: 'https://www.nizius.co.jp/sun58/wp-content/themes/sun_58/src/assets/images/fv-slide_img01.jpg'},
        { src: 'https://www.nizius.co.jp/sun58/wp-content/themes/sun_58/src/assets/images/fv-slide_img03.jpg'},
      ];
    } else {
      var responsiveImage = [//タブレットサイズ（768px）以下用の画像
      { src: 'https://www.nizius.co.jp/sun58/wp-content/themes/sun_58/src/assets/images/fv-slide_img02.jpg'},
      { src: 'https://www.nizius.co.jp/sun58/wp-content/themes/sun_58/src/assets/images/fv-slide_img01.jpg'},
      { src: 'https://www.nizius.co.jp/sun58/wp-content/themes/sun_58/src/assets/images/fv-slide_img03.jpg'},
      ];
    }

//Vegas全体の設定

    $('#slider').vegas({
        overlay: false,//画像の上に網線やドットのオーバーレイパターン画像を指定。
        transition: 'blur',//切り替わりのアニメーション。http://vegas.jaysalvat.com/documentation/transitions/参照。fade、fade2、slideLeft、slideLeft2、slideRight、slideRight2、slideUp、slideUp2、slideDown、slideDown2、zoomIn、zoomIn2、zoomOut、zoomOut2、swirlLeft、swirlLeft2、swirlRight、swirlRight2、burnburn2、blurblur2、flash、flash2が設定可能。
        transitionDuration: 2000,//切り替わりのアニメーション時間をミリ秒単位で設定
        delay: 10000,//スライド間の遅延をミリ秒単位で。
        animationDuration: 20000,//スライドアニメーション時間をミリ秒単位で設定
        animation: 'kenburns',//スライドアニメーションの種類。http://vegas.jaysalvat.com/documentation/transitions/参照。kenburns、kenburnsUp、kenburnsDown、kenburnsRight、kenburnsLeft、kenburnsUpLeft、kenburnsUpRight、kenburnsDownLeft、kenburnsDownRight、randomが設定可能。
        slides: responsiveImage,//画像設定を読む
      });

  $(function (){
      $('.slider').slick({
        autoplay: true,       //自動再生
        autoplaySpeed: 2000,  //自動再生のスピード
        speed: 800,           //スライドするスピード
        dots: true,           //スライド下のドット
        arrows: false,         //左右の矢印
        infinite: true,       //永久にループさせる
        slidesToShow: 1.1,
        responsive: [
          {
            breakpoint: 400, // 399px以下のサイズに適用
            settings: {
            slidesToShow: 1.1,
            },
          },
        ],
      });
      // ビューポートに入ったときに設定を変更する関数
  function triggerScroll(targetObj) {
    let targetName = targetObj.attr("id"); //確認用
    let targetFlag = false;
    let scrollTop = $(window).scrollTop();
    let scrollBottom = scrollTop + $(window).height();
    let targetTop = targetObj.offset().top;
    let targetBottom = targetTop + targetObj.height();
   // ロード時の表示用
    if (scrollBottom > targetTop && scrollTop < targetBottom) {
        if (!targetFlag) {
            targetObj.slick('slickPlay');
            targetFlag = true;
        }
    } else {
            targetObj.slick('slickPause');
            targetFlag = false;
    }
  
    $(window).on('scroll', function () {
        scrollTop = $(window).scrollTop();
        scrollBottom = scrollTop + $(window).height();
        targetTop = targetObj.offset().top;
        targetBottom = targetTop + targetObj.height();
        if (scrollBottom > targetTop && scrollTop < targetBottom) {
            // スクロール位置に来たときにautoplayを開始
            if (!targetFlag) {

                targetObj.slick('slickPlay');
                targetFlag = true;
            }
        } else {
            // 見えなくなったらautoplayを停止
            if (targetFlag) {
                targetObj.slick('slickPause');
                targetFlag = false;
            }
        }
      });
      }
      triggerScroll($('.slider'));
  });



// SP 
// hamburgerメニュー
$(".hd-hamburger_block").click(function () {
    $(this).toggleClass('active');
    $("#g-nav").toggleClass('panelactive');//ナビゲーションにpanelactiveクラスを付与
});

// Gnabi
$("#g-nav a").click(function () {//ナビゲーションのリンクがクリックされたら
    $(".hd-hamburger_block").removeClass('active');//ボタンの activeクラスを除去し
    $("#g-nav").removeClass('panelactive');//ナビゲーションのpanelactiveクラスも除去
});

// スクロールするとロゴの色変更
$(function () {
    $(window).on("scroll", function () {
      const sliderHeight = $("#tp-intro").height();
      if (sliderHeight - 1800 < $(this).scrollTop()) {
        $(".js-header").addClass("headerColorScroll");
      } else {
        $(".js-header").removeClass("headerColorScroll");
      }
    });
  });

  console.clear()